// src/features/onboarding/constants/steps.ts

/**
 * ONBOARDING STEPS CONFIGURATION
 * 
 * Total steps: 4 (streamlined from 8)
 */

export const TOTAL_STEPS = 4;

export const STEP_TITLES = {
  1: 'Your Identity',
  2: 'Your Business',
  3: 'Your Ideal Customer',
  4: 'Review & Launch',
} as const;
